<template>
  <div v-if="field && field.value" class="right-column-content">
    <sc-rich-text :field="field" />
  </div>
</template>

<script>
import { RichText } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-ResourceRightColumnContent',
  props: {
    field: {
      type: Object
    }
  },
  components: {
    ScRichText: RichText
  }
};
</script>

<style lang="scss" scoped>
.right-column-content {
  &:deep() {
    h5 {
      margin: 1rem auto;
    }
    > div {
      > img {
        padding: 1rem 0;
        box-sizing: border-box;
        max-width: min(300px, 100%);
        @include ie10-up {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
